import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SnackBarModule } from '@feature/snack-bar/snack-bar.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from '@shared/dialog/dialog.module';

import { HttpErrorInterceptor } from './http-error.interceptor';
import { NetworkAwareInterceptor } from '@core/network/network-aware.interceptor';

const imports: NgModule['imports'] = [DialogModule, SnackBarModule];

@NgModule({
  declarations: [],
  imports: [...imports, CommonModule, TranslateModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkAwareInterceptor,
      multi: true,
    },
  ],
})
export class ErrorHandlerModule {}
